"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LoggerSelector {
    static setLogger(log) {
        Object.assign(this.log, log);
    }
}
exports.default = LoggerSelector;
LoggerSelector.log = {};
//# sourceMappingURL=LoggerSelector.js.map